import { Injectable, Provider } from '@angular/core';
import {
  PracticeActivityQuery,
  PracticeActivityService,
  PracticeActivityStoreModel,
} from '@examdojo/practice-activity';
import {
  ACTIVITY_MISMATCH_ADAPTER,
  ActivityMismatchAdapter,
  FetchAttemptWhenMismatchEffectService,
} from '@examdojo/question';

@Injectable()
export class PracticeActivityMismatchAdapter implements ActivityMismatchAdapter<PracticeActivityStoreModel> {
  constructor(
    private readonly practiceActivityQuery: PracticeActivityQuery,
    private readonly practiceActivityService: PracticeActivityService,
  ) {}

  readonly ongoingActivityId$ = this.practiceActivityQuery.inProgressPracticeActivityId$;

  selectEntity(id: string) {
    return this.practiceActivityQuery.selectEntity(id);
  }

  fetchAttempt(attemptId: string, activity: PracticeActivityStoreModel) {
    return this.practiceActivityService.fetchQuestionAttempts(attemptId, activity.id);
  }
}

export function providePracticeActivityMismatchEffect(): Provider[] {
  return [
    PracticeActivityMismatchAdapter,
    {
      provide: ACTIVITY_MISMATCH_ADAPTER,
      useExisting: PracticeActivityMismatchAdapter,
    },
    FetchAttemptWhenMismatchEffectService,
  ];
}
